module.exports = __webpack_public_path__ + "img/Balance-2.277a0337.jpg";